import React from "react";
import PropTypes from "prop-types";
import { RightPanelPortal, Loader } from "components";
import { Slide } from "components/Animations";
import { css } from "react-emotion";
import i41 from "assets/images/i41.svg";

const propTypes = {
  query: PropTypes.object.isRequired,
  title: PropTypes.string,
  tripleDotBtn: PropTypes.object,
  togglePanel: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  children: PropTypes.any.isRequired,
  fetching: PropTypes.bool.isRequired,
  error: PropTypes.string,
  noSearch: PropTypes.bool
};

class RightPanelContainer extends React.PureComponent {
  state = { company: null, fetching: false };

  componentDidMount() {
    const { query, fetchData } = this.props;
    if (query.panel_id && fetchData) {
      fetchData(query.panel_id);
    }
  }

  componentDidUpdate(oldProps) {
    if (!this.props.fetchData) return;
    if (this.props.query.panel_id && this.props.query.panel_id !== oldProps.query.panel_id) {
      this.props.fetchData(this.props.query.panel_id);
    }
  }

  render() {
    const { query, title, tripleDotBtn, togglePanel, children, fetching, error, noSearch } = this.props;

    return (
      <RightPanelPortal>
        <Slide
          in={Boolean(query.panel_id)}
          className={noSearch ?  "aside--right-panel-top aside--right-panel" : "aside--right-panel"}
          style={{ top: noSearch ? 91 : 155, zIndex: 2 }}
        >
          <div className="aside--right-panel-content-wrapper">
            <div className="arp--head">
              <div className="arp--head-label">{title}</div>
              {tripleDotBtn}
              <button className="close-btn" onClick={togglePanel}>
                <img src={i41} alt="" />
              </button>
            </div>
            <div className="arp--content relative">
              {children}
              {fetching && (
                <div className={overlay} style={noSearch ? {minHeight: "calc(100vh - 90px)"} : null}>
                  <Loader absolute={true} timeout={50} />
                </div>
              )}
            </div>
          </div>
          {Boolean(error) && (
            <div className={overlay} style={noSearch ? {minHeight: "calc(100vh - 90px)"} : null}>
              <div className={errorClass}>
                <span>{error}</span>
              </div>
            </div>
          )}
        </Slide>
      </RightPanelPortal>
    );
  }
}

RightPanelContainer.propTypes = propTypes;
export default RightPanelContainer;

const overlay = css`
  min-height: calc(100vh - 170px);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
  z-index: 4;
  cursor: not-allowed;
  transition: 200ms;
  animation: show 200ms;
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const errorClass = css`
  display: flex;
  text-align: center;
  height: 100%;
  align-items: center;
  > * {
    margin: 0 auto;
    font-weight: 500;
    font-size: 18px;
    font-family: Barlow Condensed;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui/RightPanelContainer.jsx